<template>
  <div>
    <div v-if="loading">
    `  <div class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>
    <div v-else class="app-container">
      <div class="banner m-prof-banner">
        <img v-if="viewUser.bg_img" :src="viewUser.bg_img[0].url" alt="bg-image" class="h-100" />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
        <!-- <img :src="viewUser.bg_img ? viewUser.bg_img[0].url : `../../../../assets/images/defaultBackImg.jpg`" alt="" /> -->
      </div>
      <div class="profile-subnav">
        <div class="dovemed-wrapper w-100">
          <div class="d-flex justify-content-between">
            <div class="nav-sec p-4">
              <div class="mt-1 profile-tabs">
                <div
                  id="updates"
                  :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs cp' : 'tabs cp'"
                  :style="
                    this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                      ? { color: getPrimaryColor(), background: getPrimary50Color() }
                      : { color: '#0F1734' }
                  "
                  @click="handletab($event)"
                >
                  Updates
                </div>
                <div
                  id="about"
                  :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs cp' : 'tabs cp'"
                  :style="
                    this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                      ? { color: getPrimaryColor(), background: getPrimary50Color() }
                      : { color: '#0F1734' }
                  "
                  @click="handletab($event)"
                >
                  About
                </div>
                <div
                  :style="
                    this.$route.path.includes('ViewAllCircle') ||
                    this.$route.path.includes('self') ||
                    this.$route.path.includes('hospitals') ||
                    this.$route.path.includes('clinics') ||
                    this.$route.path.includes('nfp') ||
                    this.$route.path.includes('hcp') ||
                    this.$route.path.includes('providers')
                      ? { color: getPrimaryColor(), background: getPrimary50Color() }
                      : { color: '#0F1734' }
                  "
                  id="circles"
                  :class="
                    this.$route.path.includes('ViewAllCircle') ||
                    this.$route.path.includes('self') ||
                    this.$route.path.includes('hospitals') ||
                    this.$route.path.includes('clinics') ||
                    this.$route.path.includes('nfp') ||
                    this.$route.path.includes('hcp') ||
                    this.$route.path.includes('providers')
                      ? 'active-tabs'
                      : 'tabs'
                  "
                  @click="handletab($event)"
                >
                  Circles
                </div>
                <a-dropdown :trigger="['click']" :getPopupContainer="trigger => trigger.parentNode" v-model="displayDots2W">
                  <div
                    :style="
                      this.$route.path.includes('muteduser') ||
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? { color: getPrimaryColor(), background: getPrimary50Color() }
                        : { color: '#0F1734' }
                    "
                    id="reviews"
                    :class="
                      this.$route.path.includes('muteduser') ||
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? 'active-tabs'
                        : 'tabs'
                    "
                  >
                    <div
                      :style="
                        this.$route.path.includes('muteduser') ||
                        this.$route.path.includes('qa') ||
                        this.$route.path.includes('polls') ||
                        this.$route.path.includes('saved') ||
                        this.$route.path.includes('profilerev') ||
                        this.$route.path.includes('medrev') ||
                        this.$route.path.includes('profilercmnd') ||
                        this.$route.path.includes('treatmentrcmnd')
                          ? { color: getPrimaryColor() }
                          : ''
                      "
                      class="tabe"
                    >
                      <!-- {{ selectedTab }} -->
                      {{ "Reviews & More" }}
                      <font-awesome-icon size="1x" :icon="displayDots2W ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
                    </div>
                  </div>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item
                        id="qa"
                        @click="
                          () => {
                            selectedTab = 'Q&A'
                            $router.push({ name: 'ViewAdvocateQA' })
                          }
                        "
                        class="card-item"
                      >
                        Q&A
                      </a-menu-item>
                      <a-menu-item
                        id="polls"
                        @click="
                          () => {
                            selectedTab = 'Polls'
                            $router.push({ name: 'ViewAdvocatePolls' })
                          }
                        "
                        class="card-item"
                      >
                        Polls
                      </a-menu-item>
                      <a-menu-item
                        id="saved"
                        @click="
                          () => {
                            selectedTab = 'Saved'
                            $router.push({ name: 'ViewAdvocateFav' })
                          }
                        "
                        class="card-item"
                      >
                        Saved
                      </a-menu-item>
                      <!-- <a-menu-item id="profilerev" @click="()=> 
                        {
                          selectedTab='Profile Reviews';
                          $router.push({ name: 'viewPatientProfileReview' })
                        }"
                        class="card-item" >
                          Profile Reviews
                        </a-menu-item> -->
                      <a-menu-item
                        id="medrev"
                        @click="
                          () => {
                            selectedTab = 'Medication Reviews'
                            $router.push({ name: 'viewAdvocateMedReview' })
                          }
                        "
                        class="card-item"
                      >
                        Medication Reviews
                      </a-menu-item>
                      <!-- <a-menu-item id="profilercmnd" @click="() =>
                        {
                          selectedTab='Profile Recommendations';
                          $router.push({ name: 'viewPatientProfileRec' })
                        }" class="card-item">
                          Profile Recommendations
                        </a-menu-item> -->
                      <a-menu-item
                        id="treatmentrcmnd"
                        @click="
                          () => {
                            selectedTab = 'Treatment Recommendations'
                            $router.push({ name: 'viewAdvocateTreatmentRec' })
                          }
                        "
                        class="card-item"
                      >
                        Treatment Recommendations
                      </a-menu-item>
                      <!-- <a-menu-item id="profilercmnd" @click="()=>
                        {
                          selectedTab='Muted User'
                          $router.push({ name: 'viewAdvocateMutedUser' })
                        }" class="card-item" >
                          Muted User
                        </a-menu-item> -->
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
            </div>
          </div>

          <!-- buttons -->
        </div>
      </div>
      <!-- ------------------------ Mobile View ---------------------------------------------------------- -->
      <div class="circle-card m-prof position-relative fix-padding-mobile">
        <div class="circle-card-content text-center">
          <a-avatar :style="{ color: ' #ffffff !important', 'background-color': viewUser.url ? viewUser.url : '' ? '' : '#C997C5' }" :size="160" :src="viewUser.url" class="text-capitalize">
            {{ viewUser.display_name[0] }}
          </a-avatar>
          <button class="threedot-menu mob" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => $refs.drawerShareRef.show()">
            <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
          </button>
          <div class="doc-info">
            <p class="doc-name" :style="{ 'margin-top': '24px', 'text-align': 'left' }">
              {{ viewUser.display_name | humanize(false) }}
            </p>
            <div class="tags">
              <div class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">
                <font-awesome-icon class="icon" :icon="['fal', 'bullhorn']" :style="{ color: getPrimaryColor() }" />
                Advocate
              </div>
              <div v-if="profileData.represent_organization" class="support-tag">Supporting {{ profileData.represent_organization }}</div>
            </div>
            <p :style="{ color: '#0F1734', 'margin-top': '17.5px !important', display: 'flex', gap: '8px' }" v-if="viewUser.location && viewUser.location[0].city" class="m-0 doc-loc text-truncate">
              <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
              <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
              <span class="m-0 loc">
                {{ viewUser.location[0].city | humanize(false) }}
                {{ viewUser.location[0].state | humanize(false) }}
              </span>
            </p>
            <div class="join-detail" v-if="joinedDate">Member since: {{ formatDate(joinedDate) }}</div>
            <div class="statistics">
              <div class="circle-mem">
                <span class="num">{{ viewUser.no_of_members ? viewUser.no_of_members : "0" }}</span>
                <span class="num-text">Circle Members</span>
              </div>
              <div class="vertical-seperator"></div>
              <div class="circle-on">
                <span class="num"> {{ viewUser.no_of_circle_on ? viewUser.no_of_circle_on : "0" }}</span>
                <span class="num-text">Circle On</span>
              </div>
            </div>
          </div>
        </div>
        <div class="circle-card-footer">
          <div class="w-100 text-center" :style="{ display: 'flex', 'flex-direction': 'column', gap: '1rem' }">
            <a-button
              :loading="loadingbtn"
              class="dovemed-button font-white primary-button"
              :style="{ background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': viewUser.on_circle ? 'none' : 'all' }"
              @click="addToCircle"
            >
              {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
              <i v-if="viewUser.on_circle" class="fa fa-check" aria-hidden="true"></i>
            </a-button>

            <a-button class="dovemed-button primary-button font-white" :style="{ background: getPrimaryColor(), cursor: 'pointer' }" @click="() => $refs.MessageUserModal.ShowModal(viewUser)">
              Message
            </a-button>
          </div>
        </div>
      </div>
      <div class="m-prof-sub">
        <ul class="sub-nav text-center">
          <li
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs cp' : 'tabs cp'"
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            @click="$router.push({ name: 'ViewAdvocateUpdates' })"
          >
            Updates
          </li>
          <li
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs cp' : 'tabs cp'"
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            @click="handletab($event)"
          >
            About
          </li>
          <div
            :style="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path.includes('nfp') ||
              this.$route.path.includes('hcp') ||
              this.$route.path.includes('providers')
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="circles"
            :class="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path.includes('nfp') ||
              this.$route.path.includes('hcp') ||
              this.$route.path.includes('providers')
                ? 'active-tabs'
                : 'tabs'
            "
            @click="handletab($event)"
          >
            Circles
          </div>
            <div
              @click="() => $refs.drawerMenuRef.show()"
              :style="
                this.$route.path.includes('muteduser') ||
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? { color: getPrimaryColor(), background: getPrimary50Color() }
                  : { color: '#0F1734' }
              "
              id="reviews"
              :class="
                this.$route.path.includes('muteduser') ||
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? 'active-tabs'
                  : 'tabs'
              "
            >
              <div
                :style="
                  this.$route.path.includes('muteduser') ||
                  this.$route.path.includes('qa') ||
                  this.$route.path.includes('polls') ||
                  this.$route.path.includes('saved') ||
                  this.$route.path.includes('profilerev') ||
                  this.$route.path.includes('medrev') ||
                  this.$route.path.includes('profilercmnd') ||
                  this.$route.path.includes('treatmentrcmnd')
                    ? { color: getPrimaryColor() }
                    : ''
                "
                class="tabe"
              >
                <!-- {{ selectedTab }} -->
                {{ "Reviews & More" }}
                <font-awesome-icon size="1x" :icon="displayDots2M ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
              </div>
            </div>
            <DrawerModal ref="drawerMenuRef">
              <div @click="() => $refs.drawerMenuRef.close()">
                <a-menu-item
                  id="qa"
                  @click="
                    () => {
                      selectedTab = 'Q&A'
                      $router.push({ name: 'ViewAdvocateQA' })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Q&A
                </a-menu-item>
                <a-menu-item
                  id="polls"
                  @click="
                    () => {
                      selectedTab = 'Polls'
                      $router.push({ name: 'ViewAdvocatePolls' })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Polls
                </a-menu-item>
                <a-menu-item
                  id="saved"
                  @click="
                    () => {
                      selectedTab = 'Saved'
                      $router.push({ name: 'ViewAdvocateFav' })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Saved
                </a-menu-item>
                <!-- <a-menu-item id="profilerev" @click="()=> 
                        {
                          selectedTab='Profile Reviews';
                          $router.push({ name: 'viewPatientProfileReview' })
                        }"
                        class="card-item" >
                          Profile Reviews
                        </a-menu-item> -->
                <a-menu-item
                  id="medrev"
                  @click="
                    () => {
                      selectedTab = 'Medication Reviews'
                      $router.push({ name: 'viewAdvocateMedReview' })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Medication Reviews
                </a-menu-item>
                <!-- <a-menu-item id="profilercmnd" @click="() =>
                        {
                          selectedTab='Profile Recommendations';
                          $router.push({ name: 'viewPatientProfileRec' })
                        }" class="card-item">
                          Profile Recommendations
                        </a-menu-item> -->
                <a-menu-item
                  id="treatmentrcmnd"
                  @click="
                    () => {
                      selectedTab = 'Treatment Recommendations'
                      $router.push({ name: 'viewAdvocateTreatmentRec' })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Treatment Recommendations
                </a-menu-item>
                <!-- <a-menu-item id="profilercmnd" @click="()=>
                        {
                          selectedTab='Muted User'
                          $router.push({ name: 'viewAdvocateMutedUser' })
                        }" class="card-item" >
                          Muted User
                        </a-menu-item> -->
              </div>
          </DrawerModal>
        </ul>
      </div>

      <div class="dovemed-wrapper m-prof-wrapper py-4 padding-fix">
        <div class="row" :style="{ 'margin-top': '10px' }">
          <div class="col-md-4 col-lg-4 d-prof-progress">
            <!-- <div class='ad-container'></div> -->

            <div class="d-flex advocate-profile-card-container">
              <button class="threedot-menu" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => (displayDots = !displayDots)">
                <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />

                <div
                  v-if="displayDots"
                  :style="{ display: 'flex', 'flex-direction': 'column', 'align-self': 'flex-end', 'z-index': '1' }"
                  :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`"
                >
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.ShareProfileModal.showModal()
                      }
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path
                        d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                        fill="black"
                      /></svg
                    >Share Profile
                  </p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.reportContentModal.show('', 15)
                      }
                    "
                  >
                    <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 font20" />Report
                  </p>
        <p class="card-item" @click="muteUser(currentCircle.id, { id: viewUser.id, role: viewUser.role })"><font-awesome-icon :icon="['fal', 'comment-alt-slash']" class="mr-2 w20" />Mute User</p>
                </div>
              </button>

              <div class="profile-image mr-3 position-relative">
                <a-avatar :style="{ color: ' #ffffff !important', 'background-color': viewUser.url ? viewUser.url : '' ? '' : '#C997C5' }" :size="150" :src="viewUser.url" class="text-capitalize">
                  {{ viewUser.display_name[0] }}
                </a-avatar>
              </div>
              <div class="doc-info">
                <p class="m-0 doc-name text-capitalize" v-if="viewUser">
                  {{ viewUser.display_name | humanize(false) }}
                </p>
                <div class="tags">
                  <div class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">
                    <font-awesome-icon class="icon" :icon="['fal', 'bullhorn']" :style="{ color: getPrimaryColor() }" />
                    Advocate
                  </div>
                  <div v-if="profileData.represent_organization" class="support-tag">Supporting {{ profileData.represent_organization }}</div>
                </div>
                <p
                  :style="{ color: '#0F1734', 'margin-top': '17.5px !important', display: 'flex', gap: '8px' }"
                  v-if="viewUser.location && viewUser.location[0].city"
                  class="m-0 doc-loc text-truncate"
                >
                  <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                  <span class="m-0 loc">
                    {{ viewUser.location[0].city }},
                    {{ viewUser.location[0].state }}
                  </span>
                </p>
                <div class="join-detail" v-if="joinedDate">Member since: {{ formatDate(joinedDate) }}</div>
              </div>

              <div class="d-flex justify-content-center mt-5">
                <div class="d-flex flex-row info-phy claim-card" :style="{ 'margin-top': '16px', padding: '24px 8px', width: '335px', height: '92px', border: 'none' }">
                  <div class="d-flex flex-column" :style="{ 'margin-right': '45px', 'text-align': 'center', 'padding-left': '30px', border: 'none' }">
                    <p class="prof-details-value">
                      {{ viewUser.no_of_members ? viewUser.no_of_members : "0" }}
                    </p>
                    <p class="prof-details-title">Circle Members</p>
                  </div>
                  <div class="divider" :style="{ background: '#CBD5E1', border: '1px solid #CBD5E1', height: '36px' }"></div>
                  <div class="d-flex flex-column" :style="{ 'padding-left': '70px', 'text-align': 'center' }">
                    <p class="prof-details-value">
                      {{ viewUser.no_of_circle_on ? viewUser.no_of_circle_on : "0" }}
                    </p>
                    <p class="prof-details-title">Circle On</p>
                  </div>
                </div>
              </div>

              <div class="btns mt-3 d-flex flex-column" :style="{ gap: '16px' }">
                <a-button
                  :loading="loadingbtn"
                  :style="{ background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': viewUser.on_circle ? 'none' : 'all' }"
                  class="dovemed-button font-white primary-button review-btns"
                  @click="addToCircle"
                >
                  {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
                  <i v-if="viewUser.on_circle" class="fa fa-check" aria-hidden="true"></i>
                </a-button>
                <!-- message button added -->

                <button
                  class="dovemed-button primary-button font-white review-btns"
                  :style="{ background: getPrimaryColor(), cursor: 'pointer' }"
                  @click="() => $refs.MessageUserModal.ShowModal(viewUser)"
                >
                  Message
                </button>
              </div>

              <!-- <div class="mt-5 w-100 mb-4" :style="{ 'z-index': '10' }">
                <div class="d-flex align-items-center mb-2">
                  <h5 class="m-0 gray700 font20 fw700 flex1">Profile Completion</h5>
                  <button
                    class="d-flex align-items-center gap4 px-3 py-1 br8 fw700 font14"
                    :style="{ background: getPrimary50Color(), color: getPrimaryColor(), border: 'none' }"
                    @click="handleProfileEdit"
                  >
                    <font-awesome-icon :style="{ color: getPrimary300Color() }" :icon="['fas', 'pen']" class="font14" />
                    Edit
                  </button>
                </div>
                <a-progress :key="percentTotal" :percent="percentTotal" class="custom-progress" :strokeColor="getPrimaryColor()" :format="percent => `${percent}%`" />

                <p class="mt-4 mb-2 gray700 font16 fw700">Complete Profile</p>

                <div v-if="options.length">
                  <div v-for="(item, index) in options" :key="index">
                    <div :class="`${index % 2 === 0 ? 'bg-white' : 'bg-gray100'} d-flex align-items-center px-2 py-3`">
                      <font-awesome-icon class="success500 font20 ml-1" :icon="['fas', 'check-circle']" v-if="item.done" />
                      <p class="m-0 gray700 font16 ml-2">{{ `${item.display_name} - ${item.value}%` }}</p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 top">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <ReportContentModal ref="reportContentModal" />
    <ShareProfileModal ref="ShareProfileModal" />
    <MessageUserModal ref="MessageUserModal" />
    <DrawerModal ref="drawerShareRef">
      <div @click="() => $refs.drawerShareRef.close()">
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.ShareProfileModal.showModal()
            }
          "
        >
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.reportContentModal.show('', 15)
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 font20" />Report
        </p>
        <p class="drawer-item" @click="muteUser(currentCircle.id, { id: viewUser.id, role: viewUser.role })"><font-awesome-icon :icon="['fal', 'comment-alt-slash']" class="mr-2 w20" />Mute User</p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import AdvocateAbout from "./ViewAdvocateAbout"
import AdvocateCircles from "./ViewAdvocateCircles"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import s3Upload from "../../../../utilities/imageUploader"
import ShareProfileModal from "../../../Modals/ShareProfileModal.vue"
import MessageUserModal from "../../../Modals/MessageUserModal.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faFlag } from "@fortawesome/pro-light-svg-icons"
import ReportContentModal from "../../../Modals/ReportContent.vue"
import DrawerModal from "../../../Modals/DrawerModal.vue"

library.add(faFlag)
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AdvocateProfile",
  components: {
    AdvocateAbout,
    AdvocateCircles,
    ShareProfileModal,
    MessageUserModal,
    ReportContentModal,
    DrawerModal,
  },
  data() {
    return {
      loading: true,
      user: null,
      displayDots: null,
      loadingbtn: false,
      displayDots: false,
      displayDots2: false,
      displayDots2W: false,
      displayDots2M: false,
      selectedTab: "Reviews & More",
      profileData: {},
      joinedDate: null,
      // percentTotal: 0,
      // options: [],
      // advocateOptions: [
      //   { key_name: "file_name", display_name: "Upload a profile image", value: "20", done: false },
      //   { key_name: "circle", display_name: "Add people to your circle", value: "20", done: false },
      //   { key_name: "display_name", display_name: "Display Name", value: "20", done: false },
      //   { key_name: "location", display_name: "Location", value: "10", done: false },
      //   { key_name: "dob", display_name: "Birthday", value: "10", done: false },
      //   { key_name: "gender", display_name: "Gender", value: "10", done: false },
      //   { key_name: "represent_organization", display_name: "Represent Organization", value: "10", done: false },
      // ],
    }
  },

  created() {
    if (
      Number(this.$route.params.id) === this.authUser.user.id &&
      'advocate' === this.authUser.user.role
    ) {
      this.routeToAuthProfile(this.authUser.user.role);
    } else {
      this.fetchUser(this.$route.params.id).then(()=> this.loading = false)
      console.warn("ViewAdvocateProfile.vue is created")
      // window.addEventListener("mouseup", () => {
      //   if (this.displayDots) {
      //     setTimeout(() => {
      //       this.displayDots = false
      //     }, 100)
      //   }
      // })
    }
  },

  watch: {
    selectedTab: {
      handler() {
        this.displayDots2M = false
        this.displayDots2W = false
      },
      immediate: true,
    },
  },

  methods: {
    handleProfileEdit() {
      this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/about` })
    },

    addToCircle() {
      this.loadingbtn = true
      UserRepository.addToCircle(this.viewUser, this.currentCircle.id)
        .then(res => {
          UserRepository.getOtherUserProfile(this.viewUser, this.currentCircle.id)
            .then(res => {
              const data = { ...res.data.data.user_info, on_circle: res.data.data.on_circle, request_to_add: res.data.data.request_to_add, no_of_members: res.data.data.no_of_members }
              this.loadingbtn = false
              this.$store.commit("User/setViewUser", { data })
              this.fetchUser()
            })
            .catch(err => {
              this.loadingbtn = false
            })
        })
        .catch(err => {
          this.loadingbtn = false
        })
    },

    handletab(event) {
      this.displayDots2M = false
      this.displayDots2W = false
      switch (event.target.id) {
        case "updates":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/updates` })
          break
        case "about":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/about` })
          break
        case "circles":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/circles/ViewAllCircle` })
          break
        case "qa":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/qa` })
          break
        case "saved":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/favorites` })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/updates` })
          break
      }
    },
    /**
     * Handle Profile image Upload
     */
    async handleProfilePicUpload() {
      const file = this.$refs.file.files[0]
      this.$refs.file.value = ""
      try {
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const payload = { file_name: urlData.data.data.filename[0] }
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user)
        const authUserData = updateData.data.data[0]
        this.$store.commit("User/setAuthUserProfile", authUserData)
      } catch (err) {}
    },

    /**
     * Handle Background image Upload
     */
    async handleBackgroundPicUpload() {
      const file = this.$refs.bg.files[0]
      this.$refs.bg.value = ""
      try {
        const user = JSON.parse(localStorage.getItem("user"))
        const headers = { Authorization: `Bearer ${user.user.token}` }
        const urlData = await this.$http.post(`${process.env.BASE_API_URL}/backgroundimage/`, { image: "people", file_name: file.name }, { headers })
        const url = `${process.env.BASE_API_URL}/user/?user_id=${user.user.id}`
        const payload = { bg_img: urlData.data.data.id }
        const updateData = await this.$http.put(url, payload, { headers })
      } catch (err) {}
    },

    /**
     * Fetch user profile data
     */
    async fetchUser(userId) {
      const res = await UserRepository.getOtherUserProfile({role: 'advocate', id: this.$route.params.id}, this.currentCircle.id)
      const data = {
        ...res.data.data.user_info,
        on_circle: res.data.data.on_circle,
        request_to_add: res.data.data.request_to_add,
        no_of_members: res.data.data.no_of_members,
        no_of_circle_on: res.data.data.no_of_circle_on,
      }
      this.joinedDate = res.data.data.user_info.joined_date || null
      this.$store.commit("User/setViewUser", { data })

      const res2 = await UserRepository.getAbout(this.viewUser, this.currentCircle.id)
      this.profileData = res2.data.data ? res2.data.data[0] : {}
    },
  },

  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
.top {
  margin-top: 14px;

  // @media screen and (max-width: 900px) {
  //   margin-top: 60px;
  // }
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  margin-bottom: 32px;
  margin-top: 48px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.join-detail {
  margin-top: 17.5px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #647490;
  display: flex;
}

.loc {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.seperator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;
  width: 335px;
  height: 16px;

  @media screen and (max-width: 700px) {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .m-prof-banner {
    height: 187px !important;
  }

  .fix-padding-mobile {
    padding: 16px !important;
  }

  .m-prof {
    box-shadow: none !important;
    background: none !important;
    bottom: 40px !important;
  }

  .m-prof-sub {
    bottom: 40px !important;
  }

  .sub-nav li a {
    list-style: none;
  }
}

.padding-fix {
  margin-top: 30px;
  padding-top: 0px;
}

.info-phy {
  p {
    margin-bottom: 0px;
  }

  .prof-details-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }

  .prof-details-value {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #0f1734;
  }
}

.review-btns {
  padding: 12px 24px;
  width: 335px;
  height: 48px;
  border-radius: 6px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.advocate-profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  // height: 937px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: -172px;
}

.profile-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  margin-left: 17px;
}

.camera-bttn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;

  i {
    vertical-align: bottom;
    color: #fff !important;
  }

  input {
    opacity: 0;
    width: 100%;
  }
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  // color: #0F1734;
}

.mob {
  @media screen and (max-width: 900px) {
    position: relative;
    // top: 140px;
    left: 301px;
    z-index: 10;
  }
}

.option-mob {
  @media screen and (max-width: 900px) {
    width: max-content;
  }
}

.profile-avatar {
  .menu-content {
    .card-item {
      padding: 10px 14px;
    }
  }
}

.banner {
  // min-height: 300px;
  // max-height: 400px;
  height: 400px;

  img {
    // height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  align-self: center;
}

.tag {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}

.tags {
  display: flex;
  width: 100%;
  // justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.support-tag {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 22px;
  background: #f1edff;
  border-radius: 4px;
  color: #906eff;
  text-transform: capitalize;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
}

.doc-info {
  .doc-name {
    margin-top: 26.5px !important;
    font-weight: 700;
    font-size: 36px;
    line-height: 46px;
    color: #0f1734;
    display: flex;
  }

  .doc-loc text-truncate,
  .doc-loc {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #0f1734;
    word-break: break-all;
  }

  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  text-align: right;
  margin-left: 365px;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Advocate/view/ViewAdvocateProfile.vue